import { db } from './../config/Fire';
import { GeoFire } from 'geofire';
import * as Constants from './../constants/nodes_database';

export const SET_PROFILE_RESTAURANT_USER = 'SET_PROFILE_RESTAURANT_USER';
export const SAVING_RESTAURANT = 'SAVING_RESTAURANT';
export const SAVED_RESTAURANT = 'SAVED_RESTAURANT';

const setProfileRestaurantUser = payload => ({ type: SET_PROFILE_RESTAURANT_USER, payload });
export const setSavingRestaurant = payload => ({ type: SAVING_RESTAURANT, payload });
export const setSavedRestaurant = payload => ({ type: SAVED_RESTAURANT, payload });

export const setProfileDataToRestaurant = payload => {
    return dispatch => {
        var isSavingRestaurant = true;
        dispatch(setSavingRestaurant(isSavingRestaurant));
        const { id, name, phone, facebook, instagram, website, repartiendoDeepLink, nearCities, country, province, city, fullAddress, neighborhood, postalCodeV2, street, lat, lng, hitos, styles, types, services, accessPeopleWithDisabilities, price } = payload;
        if(id) {
            var nearCitiesMap = {}
            if(nearCities) {
                nearCities.forEach(nearCity => {
                    nearCitiesMap[nearCity] = true
                });
            }
            return db.ref(`${Constants.RESTAURANTS}/${id}`).update({
                name,
                phone,
                facebook,
                instagram,
                website,
                repartiendoDeepLink,
                address: {
                    country,
                    province,
                    city,
                    fullAddress,
                    neighborhood,
                    postalCodeV2,
                    street,
                    hitos,
                },
                nearCities: nearCitiesMap,
                styles,
                types,
                services,
                price,
                accessPeopleWithDisabilities,
            })
            .then(() => {
                return db.ref(`${Constants.RESTAURANTS}/${id}`).once("value")
                .then((restoSnap) => {
                    const resto = restoSnap.val();
                    let geoFireRef = db.ref().child(`${Constants.RESTAURANTS}`);
                    let geoFire = new GeoFire(geoFireRef);
                    return geoFire.set(id, [parseFloat(lat), parseFloat(lng)])
                    .then(function() {
                        //console.log("getRestaurant: " + JSON.stringify(restaurant));
                        return db.ref(`${Constants.RESTAURANTS}/${id}`).once("value")
                        .then((restoGeoSnap) => {
                            var restoGeo = restoGeoSnap.val();
                            resto.l = restoGeo.l;
                            resto.g = restoGeo.g;
                            return db.ref(`${Constants.RESTAURANTS}/${id}`).update(resto)
                            .then(() => {
                                dispatch(setProfileRestaurantUser(payload));
                                dispatch(setSavingRestaurant(isSavingRestaurant = false));
                                var isSavedRestaurant = true;
                                dispatch(setSavedRestaurant(isSavedRestaurant));
                            })
                            .catch(err => {
                                console.log("not found save data");
                                dispatch(setSavingRestaurant(isSavingRestaurant= false));
                            });
                        })
                        .catch(err => {
                            console.log("not found save data");
                            dispatch(setSavingRestaurant(isSavingRestaurant= false));
                        });
                    })
                    .catch(err => {
                        console.log("not found save data");
                        dispatch(setSavingRestaurant(isSavingRestaurant= false));
                    });
                })
                .catch(err => {
                    console.log("not found save data");
                    dispatch(setSavingRestaurant(isSavingRestaurant= false));
                });
            })
            .catch(err => {
                console.log("not found save data");
                dispatch(setSavingRestaurant(isSavingRestaurant= false));
            });
        } else {
            console.log("id undefined: ");
                dispatch(setSavingRestaurant(isSavingRestaurant= false));
        }
    };
};